import { Box, Container, IconButton, Typography } from "@material-ui/core"
import { getGiftCardGetFAQ } from "api"
import { useRouter } from "next/router"
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"
import styled from "styled-components"
import BackIcon from "../Icons/BackIcon"
import FaqWrapper from "./FaqWrapper"

const StyledBox = styled(Container)`
  margin-top: 120px;
  padding-left: 60px;
  padding-right: 60px;
  margin-bottom: 120px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 94px;
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 60px;
  }
`

const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  p {
    margin-right: 8px;
  }
  :hover {
    text-decoration: underline;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 40px;
  color: #000;
  margin-bottom: 20px;
  text-align: right;
  line-height: 1;
  margin-top: 30px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: right;
    margin-top: 20px;
  }
`
const StyledWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-left: 12%;
    padding-right: 12%;
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

type FaqPageProps = {
  setRefList: Dispatch<SetStateAction<any[]>>
}

const FaqPage = ({ setRefList }: FaqPageProps) => {
  const router = useRouter()
  const [data, setData] = useState([])
  const Section1Ref = useRef(null)

  useEffect(() => {
    setRefList([Section1Ref])

    const getFaqs = async () => {
      const { data } = await getGiftCardGetFAQ()
      const sorted = data?.body.sort(function (a, b) {
        return a.order - b.order
      })
      setData(sorted)
    }
    getFaqs()
  }, [])

  return (
    <StyledBox ref={Section1Ref}>
      <StyledLink
        onClick={() => router.back()}
        onKeyDown={(e) => {
          if (e.key === "Enter") router.back()
        }}
      >
        <StyledIconBtn aria-label="חזרה לעמוד קודם">
          <BackIcon />
        </StyledIconBtn>
        <Typography variant="body1">חזרה</Typography>
      </StyledLink>

      <StyledWrapper>
        <StyledTitle>{"שאלות ותשובות בנושא גיפטקארד מקדונלד'ס"}</StyledTitle>

        {data.map((data, index) => (
          <FaqWrapper
            question={data.question}
            answer={data.answer}
            key={index}
          />
        ))}
      </StyledWrapper>
    </StyledBox>
  )
}

export default FaqPage
